import { render, staticRenderFns } from "./ActCertificado.vue?vue&type=template&id=5350b67c&scoped=true&"
import script from "./ActCertificado.vue?vue&type=script&lang=js&"
export * from "./ActCertificado.vue?vue&type=script&lang=js&"
import style0 from "./ActCertificado.vue?vue&type=style&index=0&id=5350b67c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5350b67c",
  null
  
)

export default component.exports